export const environment = {
	production: false,
	apiUrl: 'https://back.vacancies.cloud.technokratos.com/api/v1',
	yaMetrikaId: 0,
};
